export default "__VITE_ASSET__DtC8Nvuh__$_?react__"